import localScaleManager from "../../../helpers/LocalScaleManager";

export class PieTimer {
  /**
   * @param scene
   */
  constructor(scene, table) {
    this.scene = scene;
    this.table = table;
    // this.blackTimer = this.scene.add.image(0, 0, this.scene.atlasTexture, 'timer-black');
    this.blackTimer = this.scene.add.image(
      0,
      0,
      this.scene.atlasTexture,
      "timer-bottom-layer"
    );
    if (this.table) this.table.poolArray.push(this.blackTimer);

    // this.redTimer = this.scene.add.image(0, 0, this.scene.atlasTexture, 'timer-red');
    this.redTimer = this.scene.add.image(
      0,
      0,
      this.scene.atlasTexture,
      "timer-top-layer"
    );
    if (this.table) this.table.poolArray.push(this.redTimer);

    this.shape = this.scene.make.graphics();
    this.shape.fillStyle(0xffffff);
    if (this.table) this.table.poolArray.push(this.shape);

    this.timerValue = 30;
    this.timerText = this.scene.add.bitmapText(
      0,
      0,
      "digital",
      this.timerValue
    );
    this.timerText.setData("width", this.timerText.width);
    this.timerText.setData("height", this.timerText.height);
    if (this.table) this.table.poolArray.push(this.timerText);

    // this.timerText.setTint(0x00e0c7);

    this.children = this.scene.add.group();
    this.children.addMultiple([this.redTimer, this.blackTimer, this.timerText]);
    if (this.table) this.table.poolArray.push(this.children);

    this.reserveTime = 30;
    this.timer = scene.time.addEvent({
      delay: 1000, // ms
      callback: this.timeEvent,
      //args: [],
      callbackScope: this,
      repeat: -1,
    });
    this.timer.paused = true;
    this.initX = 0;
    this.initY = 0;
    if (this.table) this.table.poolArray.push(this.timer);
  }
  timeEvent() {
    this.timerValue--;
    this.timerText.setText(this.timerValue);
    this.timerText.setX(this.initX - this.timerText.width / 2);
    if (this.timerValue === 0) {
      this.timer.paused = true;
      this.timerValue = this.reserveTime;
      this.shape.clear();
      this.shape.slice(
        this.redTimer.x,
        this.redTimer.y,
        this.redTimer.displayWidth / 2,
        Phaser.Math.DegToRad(270),
        Phaser.Math.DegToRad(0),
        true
      );
      this.shape.fillPath();
    }
  }
  startTimer(time) {
    if(time <= 0) return
    this.timer.paused = false;
    this.reserveTime = Math.round(time / 1000);
    this.timerValue = this.reserveTime;
    this.timerText.setText(this.timerValue);
    this.timerText.setX(this.initX - this.timerText.width / 2);
    this.scene.tweens.addCounter({
      from: 0,
      to: 359,
      duration: this.reserveTime * 1000,
      onUpdate: (tween) => {
        let t = tween.getValue();
        this.shape.clear();
        this.shape.slice(
          this.redTimer.x,
          this.redTimer.y,
          this.redTimer.displayWidth / 2,
          Phaser.Math.DegToRad(270),
          Phaser.Math.DegToRad(270 + t),
          true
        );
        this.shape.fillPath();
      },
    });
  }
  visibilityControls(visibility) {
    Phaser.Actions.SetVisible(this.children.getChildren(), visibility);
  }
  /***
   * @param size {number}
   * @param initX {number}
   * @param initY {number}
   */
  positionControls(size, initX, initY) {
    this.initX = initX;
    this.initY = initY;
    const timerSize = size;
    const timerScale = localScaleManager.scaleSprite(
      this.redTimer,
      timerSize,
      timerSize,
      0,
      1,
      true
    );
    localScaleManager.scaleSpriteTo(this.blackTimer, timerScale);
    this.redTimer.setPosition(initX, initY);
    this.blackTimer.setPosition(initX, initY);

    this.textSize = size / 1.8;
    localScaleManager.scaleBitMapText(
      this.timerText,
      this.textSize,
      this.textSize,
      0,
      1,
      false
    );
    this.timerText.setPosition(
      initX - this.timerText.width / 2,
      initY + this.timerText.height / 4
    );

    this.shape.slice(
      this.redTimer.x,
      this.redTimer.y,
      this.redTimer.displayWidth / 2,
      Phaser.Math.DegToRad(270),
      Phaser.Math.DegToRad(0),
      true
    );

    this.shape.fillPath();

    this.mask = this.shape.createGeometryMask();

    this.redTimer.setMask(this.mask);
  }
  /***
   * @param size {number}
   * @param initX {number}
   * @param initY {number}
   */
  reposition(size, initX, initY) {
    this.initX = initX;
    this.initY = initY;
    this.redTimer.setPosition(initX, initY);
    this.blackTimer.setPosition(initX, initY);

    this.timerText.setPosition(
      initX - this.timerText.width / 2,
      initY + this.timerText.height / 4
    );
  }
}
